import React from 'react';
import { Stack } from '@mui/material';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import Grid from '@mui/material/Grid';
import { ERouteLinks } from 'models/route';
import { useTranslations } from 'hooks/useTranslations';
import { usePermission } from 'hooks/usePermission';
import { EIconTypes } from 'constants/Icons';
import { EPermission } from 'models/permissions';
import { useWeaponLicenceModule } from 'hooks/useWeaponLicenceModule';
import { useLicenceContext } from 'models/licenceContext';
import UsersRoles from './usersRoles';
import LicencesModule from './licencesModule';
import ElementsComponent from './elementsComponent';
import SystemSettings from './systemSettings';

const AdministrationPage = () => {
  const { t } = useTranslations();
  const { hasPermissions } = usePermission();
  const { hasWeaponLicenceModule } = useWeaponLicenceModule();
  const { isOnlineLicence } = useLicenceContext();

  const allElements: any[] = [];

  if (hasPermissions([EPermission.MANAGE_USERS, EPermission.MANAGE_ROLES], true)) {
    allElements.push(<UsersRoles key="usersRoles" />);
  }

  if (
    hasPermissions(
      [EPermission.MANAGE_SETTINGS, EPermission.MANAGE_WEAPON_LICENCE_CONFIGURATOR],
      true,
    ) &&
    hasWeaponLicenceModule()
  ) {
    allElements.push(<LicencesModule key="licencesModule" />);
  }

  if (hasPermissions([EPermission.VIEW_AUDIT_LOG])) {
    allElements.push(
      <ElementsComponent
        key="auditLog"
        iconType={EIconTypes.auditLogs}
        elements={[{ title: t('auditLog.header'), url: ERouteLinks.AuditLogPage }]}
      />,
    );
  }

  if (isOnlineLicence() && hasPermissions([EPermission.MANAGE_API_KEYS])) {
    allElements.push(
      <ElementsComponent
        key="apiKeys"
        iconType={EIconTypes.apiKeys}
        elements={[{ title: t('systemSettings.apiKeys'), url: ERouteLinks.ApiKeysPage }]}
      />,
    );
  }

  if (
    hasPermissions(
      [
        EPermission.MANAGE_SETTINGS,
        EPermission.MANAGE_CUSTOM_FIELDS,
        EPermission.MANAGE_DICTIONARIES,
      ],
      true,
    )
  ) {
    allElements.push(<SystemSettings key="systemSettings" />);
  }

  if (hasPermissions([EPermission.VIEW_AND_MANAGE_LICENCE])) {
    allElements.push(
      <ElementsComponent
        key="systemLicence"
        iconType={EIconTypes.systemLicence}
        elements={[{ title: t('systemLicence.apiKeys'), url: ERouteLinks.LicenceDetails }]}
      />,
    );
  }

  const n = Math.ceil(allElements.length / 2);
  const firstColumnCount = Array.from({ length: n }, (_, i) => i);

  const lastElem = allElements.length;

  const secondColumnCount = Array.from({ length: lastElem - n }, (_, i) => n + i);

  return (
    <>
      <Breadcrumbs items={[t('module.administration.name')]} />
      <StyledPageTitle variant="h4">{t('module.administration.name')}</StyledPageTitle>

      <Grid container columnSpacing={{ xs: 0, md: 2 }} sx={{ rowGap: 2 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>{firstColumnCount.map((i) => allElements[i])}</Stack>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Stack spacing={2}>{secondColumnCount.map((i) => allElements[i])}</Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AdministrationPage;
